import { useTranslation } from 'react-i18next';
import { Modal } from 'react-bootstrap';
import { Typography } from 'app/components';

import './RemoveModal.scss';

interface RemoveModalProps {
  show: boolean;
  taxonomyName?: string;
  tagCount?: number;
  isLoading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const RemoveModal = ({ show, taxonomyName, tagCount = 0, isLoading, onClose, onConfirm }: RemoveModalProps) => {
  const { t } = useTranslation(['common', 'tag']);

  return (
    <Modal show={show} centered dialogClassName="remove-modal-dialog" contentClassName="remove-modal">
      <Modal.Body className="remove-modal__content">
        <Typography variant="body-8" fontWeight="semibold">
          {t('tag:taxonomy.remove.title')}
        </Typography>

        {tagCount > 0 ? (
          <Typography variant="body-7">{t('tag:taxonomy.remove.cascade.description', { taxonomyName, count: tagCount })}</Typography>
        ) : (
          <Typography variant="body-7">{t('tag:taxonomy.remove.description')}</Typography>
        )}

        <div className="remove-modal__actions">
          <button className="btn btn-primary" onClick={onConfirm} disabled={isLoading}>
            {isLoading ? t('common:loading') : tagCount > 0 ? t('tag:taxonomy.remove.cascade.confirm') : t('tag:remove.confirm')}
          </button>

          <button className="btn btn-secondary" onClick={onClose} disabled={isLoading}>
            {t('common:cancel')}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
